module.exports = __webpack_public_path__ + "img/Block.383fea35.png";